<div class="container">
  <div class="single_element">
    <div class="quick_activity">
      <h5>المنصة <span>العلاجية</span></h5>

      <div class="quick_activity_wrap">
        <div class="row g-24">
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-1">
              <div class="icon">
                <img src="assets/images/icons/stethoscope-icon.svg" alt="" />
              </div>
              <h3>التشخيص</h3>
              <a routerLink="/auth/basic-data/Platform">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-2">
              <div class="icon">
                <img
                  src="assets/images/icons/medicine-icon-orange.svg"
                  alt=""
                />
              </div>
              <h3>العلاج</h3>
              <a routerLink="/Sas/TreatmentPlatform">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-3">
              <div class="icon">
                <img src="assets/images/icons/list-icon-info.svg" alt="" />
              </div>
              <h3>التقارير الطبية</h3>
              <a routerLink="/Sas/PatientReports">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-4">
              <div class="icon">
                <img
                  src="assets/images/icons/microscope-icon-dark.svg"
                  alt=""
                />
              </div>
              <h3>الصفحة الشخصية</h3>
              <a routerLink="/Sas/Patient-profile">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-5">
              <div class="icon">
                <img src="assets/images/icons/computer-yellow.svg" alt="" />
              </div>
              <h3>النماذج</h3>
              <a routerLink="/Sas/ModelsDashboard">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card-light-border admin-card admin-card-6">
              <div class="icon">
                <img
                  src="assets/images/icons/doctor-icon-lavender.svg"
                  alt=""
                />
              </div>
              <h3>خدمة مستشارك في التخاطب</h3>
              <a routerLink="/Sas/ConsultantPlatform">
                <img
                  src="assets/images/icons/arrow-left.svg"
                  alt="arrow icon"
                />
              </a>
            </div>
          </div>

          <!-- <div class="col-lg-4">
            <a routerLink="/auth/basic-data/Platform">
              <div class="single_quick_activity">
                <img src="assets/images/2.png" class="img-fluid" width="50" />
                <h3>التشخيص</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/TreatmentPlatform">
              <div class="single_quick_activity single_quick_activity5">
                <img src="assets/images/5.png" class="img-fluid" width="50" />
                <h3>العلاج</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/PatientReports">
              <div class="single_quick_activity single_quick_activity3">
                <img src="assets/images/7.png" class="img-fluid" width="50" />
                <h3>التقارير الطبية</h3>
              </div>
            </a>
          </div> -->
        </div>

        <!-- <div class="row">
          <div class="col-lg-4">
            <a routerLink="/Sas/Patient-profile">
              <div class="single_quick_activity single_quick_activity2">
                <img src="assets/images/1.png" class="img-fluid" width="50" />
                <h3>الصفحة الشخصية</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/ModelsDashboard">
              <div class="single_quick_activity single_quick_activity4">
                <img src="assets/images/8.png" class="img-fluid" width="50" />
                <h3>النماذج</h3>
              </div>
            </a>
          </div>

          <div class="col-lg-4">
            <a routerLink="/Sas/ConsultantPlatform">
              <div class="single_quick_activity single_quick_activity6">
                <img src="assets/images/4.png" class="img-fluid" width="50" />
                <h3>خدمة مستشارك في التخاطب</h3>
              </div>
            </a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
